import { useComponents } from "@/hooks/useComponents";

// See spinner-sizes in components2/spinners.cljs
type LoadingSize = "modal" | "table" | "text";

interface LoadingProps {
  delay?: number;
  size?: LoadingSize;
  // "inverted" - white spinner, for filled buttons
  color?: "primary" | "inverted";
}

export const Loading = (props: LoadingProps) => {
  const { MuxSpinner } = useComponents();

  return <MuxSpinner {...props} />;
};
